<template>
  <v-card class="elevation-1 my-7">
    <v-toolbar flat>
      <v-toolbar-title>Accounting Sales Unit Numbers</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="accent" dark class="mb-2" @click="addItem"> New Item </v-btn>
    </v-toolbar>
    <v-row cols class="px-4 pb-4 mx-0" v-for="(item, index) in data" :key="index">
      <v-col cols="12" lg="3" md="12" sm="12" xs="12">
        <v-select
          class="mt-2"
          :items="availableCurrencies(item)"
          v-model="item.currency"
          label="Currency"
          hide-details="auto"
          dense
          outlined></v-select>
      </v-col>
      <v-col cols="12" lg="9" md="12" sm="12" xs="12">
        <v-text-field
          class="mt-2"
          v-model="item.salesUnitNumber"
          label="Sales Unit Number"
          hide-details="auto"
          dense
          outlined>
          <template v-slot:append-outer>
            <v-btn color="primary" class="mt-2 mr-lg-n3 mt-lg-n2" icon @click="removeItem(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: ["data", "currencies"],
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        if (newData && newData.length === 0) {
          newData.push({ currency: "", salesUnitNumber: "" });
        }
      },
    },
  },
  methods: {
    addItem() {
      this.data.push({ currency: "", salesUnitNumber: "" });
    },
    removeItem(index) {
      this.data.splice(index, 1);
      if (this.data.length === 0) {
        this.data.push({ currency: "", salesUnitNumber: "" });
      }
    },
    availableCurrencies(item) {
      const usedCurrencies = this.data.map((other) => other.currency).filter((currency) => currency !== item.currency);
      return this.currencies.filter((currency) => !usedCurrencies.includes(currency));
    },
  },
};
</script>
